import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, X, FileCheck2 } from "lucide-react";
import { TERMS_SECTIONS } from "@/data/agreementTerms";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AgreementView = ({ onClose }) => {
  const [ag, setAg] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/onboarding/agreement`)
      .then(({ data }) => setAg(data))
      .catch(() => setError("No signed agreement on file."));
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 sm:items-center" data-testid="agreement-view-modal">
      <div className="flex max-h-[88vh] w-full max-w-lg flex-col rounded-t-3xl bg-white sm:rounded-3xl">
        <div className="flex items-center justify-between border-b border-line p-4">
          <p className="flex items-center gap-2 font-display text-lg font-bold text-slate-900">
            <FileCheck2 className="h-5 w-5 text-green-600" /> Signed Agreement
          </p>
          <button onClick={onClose} className="rounded-full bg-slate-100 p-2" data-testid="agreement-view-close">
            <X className="h-4 w-4 text-slate-600" />
          </button>
        </div>
        <div className="overflow-y-auto p-5">
          {error ? (
            <p className="py-8 text-center text-sm text-slate-500" data-testid="agreement-view-error">{error}</p>
          ) : !ag ? (
            <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-blaze" /></div>
          ) : (
            <>
              <div className="rounded-2xl border border-green-200 bg-green-50 p-4" data-testid="agreement-summary">
                <p className="text-xs font-bold uppercase tracking-widest text-green-700">Agreement Signed &amp; Active</p>
                <div className="mt-2 space-y-1 text-sm text-slate-700">
                  <p><span className="text-slate-500">Name:</span> <strong>{ag.full_name}</strong></p>
                  <p><span className="text-slate-500">Role:</span> <strong className="capitalize">{ag.worker_role === "driver" ? "Driver" : "Helper / Offsider"}</strong></p>
                  <p><span className="text-slate-500">Signed on:</span> <strong>{ag.signed_date}</strong></p>
                  <p><span className="text-slate-500">Terms version:</span> {ag.terms_version}</p>
                </div>
                {ag.signature_id && (
                  <div className="mt-3">
                    <p className="mb-1 text-[10px] font-bold uppercase tracking-widest text-slate-500">Your Signature</p>
                    <img src={`${API}/signatures/${ag.signature_id}`} alt="Signature" className="max-h-24 rounded-lg border border-line bg-white" data-testid="agreement-signature-img" />
                  </div>
                )}
              </div>
              <div className="mt-5 space-y-4">
                {TERMS_SECTIONS.map((s) => (
                  <div key={s.title}>
                    <p className="text-sm font-bold text-slate-900">{s.title}</p>
                    <p className="mt-1 whitespace-pre-line text-[13px] leading-relaxed text-slate-600">{s.body}</p>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
